export default {
    getImages(state) {
        return state.images;
    }
}
